/**
 * noneKnowledge — KnowledgePort adapter that returns no snippets.
 *
 * Used when Product Bible / MCP is not wired.
 */
export function createNoneKnowledge() {
  return {
    async status() { return { status: "not_configured" }; },
    async getKnowledgeFor() { return []; },
  };
}
